import { DependencyList } from 'react';
import { CSSObject } from '@emotion/react';
import { Theme } from '../themes';
import { useTheme } from './useTheme';

export const useStyleSheet = <T extends Record<string, CSSObject>>(
  cb: (theme: Theme) => T,
  /**
   * @deprecated The `deps` parameter is deprecated and has no effect.
   * Please update your code accordingly.
   */
  deps?: DependencyList,
) => {
  const theme = useTheme();
  return cb(theme);
};
